import { ESdChangeReason, EUserAccessPart, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { connect } from "react-redux";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { WithForm } from "../../../../shared/hoc/with-form";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { setNextCallbackFunction } from "../../../../store/unsaved-changes-modal/actions";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import { ZendeskLeftPanel } from "../../zendesk/zendesk-left-panel";
import SearchablePanelHeader from "../searchable-panel-header/searchable-panel-header";

export interface IZendeskPanelState {
  searchText: string;
  isSearchActive: boolean;
}

export interface IZendeskPanelProps {}

class ZendeskPanel extends PureSdComponent<IZendeskPanelProps & IWithSDProps & IWithContextProp, IZendeskPanelState> {
  constructor(props: IZendeskPanelProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {
      searchText: "",
      isSearchActive: false
    };
  }

  componentDidMount(): void {
    const searchText = this.props.sd.searchTexts[ViewPart.ZendeskPanel];
    if (searchText && searchText.length > 0) {
      this.setState({ isSearchActive: true, searchText });
    }
  }

  handleSearchInputChange = (searchText: string): void => {
    this.setState({ searchText });
    this.props.sd.setSearchTexts(ViewPart.ZendeskPanel, searchText);
  };

  deleteSearchText = (): void => {
    this.setState({ searchText: "", isSearchActive: false });
    this.props.sd.setSearchTexts(ViewPart.ZendeskPanel, "");
  };

  onNewTicketClick = (): void => {
    if (this.props.sd.isZendeskTicketCreating) return;
    this.props.sd.onZendeskTicketCreate(true);
    this.props.sd.onZendeskTicketSelect(null);
  };

  render() {
    if (this.props.sd.getVisibility(ViewPart.ZendeskPanel) !== Visibility.Visible) {
      return null;
    }

    const hasAccessCreateTicket = KMainFunctions.hasUserAccessInWorkspaceByProjectRole(
      EUserAccessPart.CreateNewTicket,
      this.props.sd.project?.projectAccess
    );

    return (
      <div className="kuika-left-panel__container">
        <SearchablePanelHeader
          searchText={this.state.searchText}
          onSearchTextChange={this.handleSearchInputChange}
          onSearchClearCallback={this.deleteSearchText}
          viewPart={ViewPart.ZendeskPanel}
          panelName="Tickets"
          isSearchActive={this.state.isSearchActive}
          setSearchActive={(value: boolean) => this.setState({ isSearchActive: value })}
          extraRightUnit={
            hasAccessCreateTicket ? (
              <KuikaButton
                data-testid="addTicketPlusButton"
                data-onboarding-id="left-panel_zendesk_plus"
                isIcon
                type="tertiary"
                color="neutral"
                disabled={this.props.sd.isZendeskTicketCreating}
                onClick={this.onNewTicketClick}
              >
                <KuikaSvg width={16} height={16} name="plus" />
              </KuikaButton>
            ) : undefined
          }
        />
        {/*
          No wrapper spinner: it was keyed on `isProjectLoaded`, which has nothing to do with
          the ticket fetch — it went away long before the tickets arrived, and came back for
          every save. The list owns its own placeholder, keyed on the fetch that actually feeds it.
        */}
        <div className="kuika-left-panel__content">
          <ZendeskLeftPanel searchText={this.state.searchText} />
        </div>
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.Loading) {
      return true;
    }
    return false;
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNextCallbackFunction: (cb: () => void) => dispatch(setNextCallbackFunction(cb))
  };
};

const zendeskPanel = connect(
  null,
  mapDispatchToProps
)(withContext<IZendeskPanelProps>(WithForm<IZendeskPanelProps>(withSD<IZendeskPanelProps>(ZendeskPanel))));
export { zendeskPanel as ZendeskPanel };
